// extracted by mini-css-extract-plugin
export default {"Card":"RegisterPage_Card__lFLDD"};